import React, { useState, useEffect } from 'react';
import profilePic from '../../images/ProfilePic.svg'

function Avatar({ name = null, image = null }) {
    const [initials, setInitials] = useState(null);

    useEffect(() => {
        if (name) {
            const names = name.split(' ');
            setInitials(`${names[0][0]}${names[1][0]}`);
        }
    }, [name])

    return (
        <div className="h-8 w-8 flex flex-col justify-center items-center rounded-full border-2 border-gray-400 bg-gray-500 text-gray-100">
            { image && <img className="rounded-full" src={image} alt="avatar" />}
            { !image && name && <p className="text-center text-sm">{initials}</p>}
            { !image && !name && <img src={profilePic} alt="" />}
        </div>
    );
}

export default Avatar;
